import moment from "moment";
export function arrayToDate(value) {
    if (value == null || value[0] == null) {
        return null;
    }
    const numbers = value.map(it => parseInt(it, 10));
    return moment(new Date(numbers[0], numbers[1], numbers[2]));
}
export function dateToArray(value) {
    if (value == null || value === "") {
        return [null, null, null];
    }
    const date = moment(value).toDate();
    return [date.getFullYear(), date.getMonth(), date.getDate()].map(String);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/formHelpers.ts